/*
    PC_FF_01 import the necessary packages and functions
*/
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getCategories, postFAQ, getFAQByID, updateFAQ } from '../../service/todo';
import { OnlyNumberSpecialChar } from '../../utils/RegHandling';
import Loader from '../../StaticComponent/Loader';
import BreadCrumbs from '../BreadCrumbs/BreadCrumbs';
import { encryptStorage } from '../../constant';

export function FAQForm() {
    /* 
        PC_FF_02 required state variables are created
    */
    let dataObj = { id: '', questions: '', answers: '', categoryID: 'Select' };
    const [state, setState] = useState(dataObj);
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let id = params.get('FAQID');
    let Mode = params.get('pMode');
    let dropDowncategoryID = { id: '', category_name: '' };
    let dropDownArraycategoryID = [dropDowncategoryID];
    const [arrDropDowncategoryID, setarrDropDowncategoryID] = useState(dropDownArraycategoryID);
    const [pagemode, setpagemode] = useState('false');
    const [questionValidation, setQuestionValidation] = useState('');
    const [answerValidation, setAnswerValidation] = useState('');
    const [categoryValidation, setcategoryValidation] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();


    useEffect(() => {
        if (encryptStorage.getItem('groupid') == 1) {
            /*
            PC_FF_04 triggers loadCategory to get the dropdown values
             */
            loadCategory();
            loadFAQEditView();
        } else {
            navigate('/', { state: { hideNav: false } });
        }
    }, []);


    const loadCategory = async () => {
        setIsLoading(false);
        let responsedata = await getCategories();

        setarrDropDowncategoryID(responsedata.data);
        setIsLoading(true);
        loadFAQEditView();
    };

    /*
        PC_FF_14 sets the pagemode and pass the faq_id to get the data for edit mode 
    */
    const loadFAQEditView = async () => {
        try {
            if (Mode === 'Edit') {
                setpagemode('true');
            }
            selecteditarray(id);
        } catch (error) { }
    };

    const selecteditarray = async (id) => {
        let responsedata = await getFAQByID({ faq_id: id });
        let valiDateobj1 = {
            id: id,
            questions: responsedata.data[0]?.questions,
            answers: responsedata.data[0]?.answers,
            categoryID: responsedata.data[0]?.category,
        };
        setState(valiDateobj1);
    };
    /*
        PC_FF_10 buildCategory will bind the values into dropdown. 
    */
    const buildCategory = () => {
        return arrDropDowncategoryID?.map((value, index) => {
            return <option value={value.id}>{value.category_name}</option>;
        });
    };

    /*
        PC_FF_03, 11 setStates the values for questions, answers, category
    */
    const OnChangeName = (e) => {
        setState({ ...state, [e.target.name]: e.target.value });
    };
    /*
        PC_FF_12 validates the data on submit clicks and invokes  
    */
    const Validation = () => {
        //
        let result = true;
        if (state.questions === '' || state.questions === undefined) {
            result = false;
            setQuestionValidation('Question is required');
        } else {
            let checkregex = OnlyNumberSpecialChar(state.questions.trim());
            if (checkregex) {
                result = false;
                setQuestionValidation('Please enter a valid question');
            } else {
                setQuestionValidation('');
            }
        }
        if (state.answers === '' || state.answers === undefined) {
            result = false;
            setAnswerValidation('Answer is required');
        } else {
            let checkregex = OnlyNumberSpecialChar(state.answers.trim());
            if (checkregex) {
                result = false;
                setAnswerValidation('Please enter a valid answer');
            } else {
                setAnswerValidation('');
            }
        }
        if (state.categoryID === '' || state.categoryID === 'Select' || state.categoryID === undefined) {
            result = false;
            setcategoryValidation('Category is required');
        }
        if (result) submitClick();
    };

    const submitClick = async () => {
        if (pagemode === 'false' || pagemode === '') {
            if (state.questions !== '' && state.answers !== '' && state.categoryID !== '') {
                let insertdata = {
                    RequiredID: '0',
                    questions: state.questions,
                    answers: state.answers,
                    categoryID: state.categoryID,
                };
                /*
                    PC_FF_15 will post the faqDetails into db and clears the input fields.
                */
                setIsLoading(false);
                let responsedata = await postFAQ(insertdata);

                setIsLoading(true);
                //
                if (responsedata.message === 'Data inserted Successfully') {
                    let valiclearoption = {
                        questions: '',
                        answers: '',
                        categoryID: 'Select',
                    };
                    setState(valiclearoption);
                    redirect();
                }
            }
        } else if (pagemode === 'true') {
            if (state.questions !== '' && state.answers !== '' && state.categoryID !== '') {
                let updateData = {
                    RequiredID: '1',
                    id: state.id,
                    questions: state.questions,
                    answers: state.answers,
                    categoryID: state.categoryID,
                };
                /*
                    PC_FF_15 will post the faqDetails into db and clears the input fields.
                */
                setIsLoading(false);
                let responsedata = await updateFAQ(updateData);
                setIsLoading(true);
                if (responsedata.message === 'Data Updated Successfully') {
                    let valiclearoption = {
                        questions: '',
                        answers: '',
                        categoryID: 'Select',
                    };
                    setState(valiclearoption);
                    redirect();
                }
            }
        }
    };
    /*
        PC_FF_19 redirects to faq list on cancel click
    */
    const redirect = () => {
        //;

        navigate(`/faq`, { state: { catId: state.categoryID == 'Select' ? 1 : state.categoryID } });
    };

    let breadCrumbsData;

    breadCrumbsData = [
        { title: 'Dashboard', path: '/overview', isActive: true },
        { title: 'How Do I ?', path: '/faq', isActive: true },
        { title: `FAQ's`, path: '/faq', isActive: true },
        { title: Mode == 'Edit' ? 'Edit FAQ' : `New FAQ`, path: '', isActive: false },
    ];

    return (
        <>
            <Loader isLoading={isLoading} />
            <div className="container-fluid coverpic mt-5">
                <div className="row justify-content-center ">
                    <div className="col-md-8 p-4 bg-white mt-4 rounded-3">
                        <BreadCrumbs data={breadCrumbsData} />
                        {/*Form structure starts Here*/}
                        <div className="col-md-12 mb-4">
                            <label className="form-label tt-bold font-15 faq-form-label" htmlFor="faq-question">
                                Question<span className="hive-form-mandatory">*</span>
                            </label>
                            <textarea
                                id="faq-question"
                                placeholder="Enter the question"
                                className="custom-comment-box hive-form-control custom-textfield form-control p-2"
                                name="questions"
                                value={state.questions}
                                onChange={(e) => {
                                    setQuestionValidation('');
                                    OnChangeName(e);
                                }}
                            />
                            <span className="text-danger">{questionValidation}</span>
                        </div>
                        <div className="col-md-12 mb-4">
                            <label className="form-label tt-bold font-15 hi faq-form-label" htmlFor="faq-answer">
                                Answer <span className="hive-form-mandatory">*</span>
                            </label>
                            <textarea
                                id="faq-answer"
                                placeholder="Enter the answer"
                                className="custom-comment-box hive-form-control custom-textfield form-control p-2"
                                name="answers"
                                value={state.answers}
                                onChange={(e) => {
                                    setAnswerValidation('');
                                    OnChangeName(e);
                                }}
                            />
                            <span className="text-danger">{answerValidation}</span>
                        </div>
                        <div className="col-md-4 mb-5">
                            <label className="form-label tt-bold font-15 faq-form-label">
                                Category <span className="hive-form-mandatory">*</span>
                            </label>
                            <select
                                className="form-select hive-form-select"
                                name="categoryID"
                                value={state.categoryID}
                                onChange={(e) => {
                                    setcategoryValidation('');
                                    OnChangeName(e);
                                }}
                            >
                                <option value="Select">Select</option>
                                {buildCategory()}
                            </select>
                            <span className="text-danger">{categoryValidation}</span>
                        </div>
                        {/*Form structure ends Here*/}

                        <div class="col-md-12 d-flex justify-content-end mb-4">
                            <button
                                type="button"
                                class="btn hive-btn-secondary"
                                onClick={() => {
                                    redirect();
                                }}
                                data-bs-dismiss="modal"
                            >
                                Cancel
                            </button>
                            <button type="button" class="btn hive-btn-primary" onClick={() => Validation()}>
                                {Mode == 'Edit' ? 'Update' : 'Save'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
